import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'linescape-enhances-sailing-schedules-with-actual-tracking-data',
  template: require('./linescape-enhances-sailing-schedules-with-actual-tracking-data.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-enhances-sailing-schedules-with-actual-tracking-data.scss')]
})
export class LinescapeEnhancesSailingScheduleswithActualTrackingData extends BlogPage {
  title = "Linescape Enhances Sailing Schedules with Actual Tracking Data";
  description = "Updating schedules with actual departure and arrival times provides subscribers with greater visibility over their shipments.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-enhances-sailing-schedules-with-actual-tracking-data/linescape-enhances-sailing-schedules-with-actual-tracking-data.ts